import { render, staticRenderFns } from "./IpcTag.vue?vue&type=template&id=9938b8fa&scoped=true"
import script from "./IpcTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./IpcTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IpcTag.vue?vue&type=style&index=0&id=9938b8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938b8fa",
  null
  
)

export default component.exports